let questions = document.querySelectorAll('.doubt__question')

function showAnswear () { this.parentElement.classList.toggle('is-active') }

if (questions.length) {
  for (let i = 0; i < questions.length; i++) { 
    questions[i].addEventListener('click', showAnswear)
  }
}
